import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faFileContract } from '@fortawesome/free-solid-svg-icons';

const TermsOfService: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="gp-page py-6">
      <div className="gp-container max-w-3xl">
        <Link to="/" className="gp-back-link mb-4">
          <FontAwesomeIcon icon={faArrowLeft} aria-hidden="true" />
          {t('common.backToHome')}
        </Link>

        <div className="gp-page-header">
          <div className="flex items-center gap-2 mb-1">
            <span className="gp-icon-tile">
              <FontAwesomeIcon icon={faFileContract} aria-hidden="true" />
            </span>
            <h1 className="gp-page-title">Terms of Service</h1>
          </div>
          <p className="gp-page-subtitle text-xs">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="gp-card space-y-5">
          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              1. Acceptance of Terms
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted">
              By accessing and using GlobalPreps, you accept and agree to be bound by the terms and provision of this
              agreement.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              2. Use License
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted mb-1.5">
              Permission is granted to temporarily access the materials on GlobalPreps for personal, non-commercial
              transitory viewing only.
            </p>
            <p className="text-sm leading-relaxed gp-text-muted">
              This license shall automatically terminate if you violate any of these restrictions and may be terminated
              by GlobalPreps at any time.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              3. User Accounts
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted">
              You are responsible for maintaining the confidentiality of your account and password. You agree to accept
              responsibility for all activities that occur under your account.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              4. Subscription and Payment
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted mb-1.5">
              Subscriptions are billed in advance on a monthly or annual basis and are non-refundable except as required
              by law.
            </p>
            <p className="text-sm leading-relaxed gp-text-muted">
              All fees are in USD unless otherwise stated. Prices are subject to change with notice.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              5. Intellectual Property
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted">
              The content, organization, graphics, design, compilation, and other matters related to GlobalPreps are
              protected under applicable copyrights, trademarks, and other proprietary rights.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              6. Limitation of Liability
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted">
              GlobalPreps shall not be liable for any indirect, incidental, special, consequential, or punitive damages
              resulting from your use of or inability to use the service.
            </p>
          </section>

          <section>
            <h2 className="text-sm font-semibold mb-1.5" style={{ color: 'var(--gp-ink)' }}>
              7. Contact Information
            </h2>
            <p className="text-sm leading-relaxed gp-text-muted">
              If you have any questions about these Terms of Service, please contact us at{' '}
              <a href="mailto:legal@globalprep.com" className="gp-link">
                legal@globalprep.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;
